export default {"src":"/_next/static/media/tractor.078616eb.svg","height":418,"width":880,"blurWidth":0,"blurHeight":0};